var map;
var mapMarkers = [];

window.initMap = function () {
  const styledMapType = new google.maps.StyledMapType(
    [ /* your long style array here */ ],
    { name: 'Styled Map' }
  );

  var isSingleLocation = document.getElementsByClassName('map-sideview');

  map = new google.maps.Map(document.getElementById("map-single"), {
    center: { lat: vlat, lng: vlng },
    zoom: 15,
    streetViewControl: false,
    mapTypeControl: false
  });

  map.mapTypes.set('styled_map', styledMapType);
  map.setMapTypeId('styled_map');

  if (window.storeLocations && window.storeLocations.length > 0) {
    setMarkers(map, window.storeLocations);
  }
};

function setMarkers(map, locations) {
  const infoWindows = [];

  locations.forEach(([info, lat, lng, iconUrl]) => {
    const latlng = new google.maps.LatLng(lat, lng);
    const marker = new google.maps.Marker({
      position: latlng,
      map: map,
      icon: {
        url: iconUrl,
        scaledSize: new google.maps.Size(32, 40)
      }
    });

    mapMarkers.push(marker);

    const infoWindow = new google.maps.InfoWindow();
    infoWindows.push(infoWindow);

    marker.addListener("click", function () {
      infoWindows.forEach(iw => iw.close());
      infoWindow.setContent(info);
      infoWindow.open(map, marker);
    });
  });
}
